import { render } from "./DonationFormStep4.vue?vue&type=template&id=82d4ffca&scoped=true&lang=html"
import script from "./DonationFormStep4.vue?vue&type=script&lang=js"
export * from "./DonationFormStep4.vue?vue&type=script&lang=js"

import "./DonationFormStep4.vue?vue&type=style&index=0&id=82d4ffca&lang=scss&scoped=true"

import exportComponent from "/Applications/MAMP/htdocs/frauenkirche/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82d4ffca"]])

export default __exports__